export default __webpack_public_path__ + "static/media/bigimage.469346e6.svg";